import {dutch as dutchLanguage} from '@internationalization/dutch.language';

export const dutch = dutchLanguage;
